import { useParams } from 'react-router-dom'
import { useAuth } from '@/hooks/useAuth'

import { AlunoRepository } from '@/pages/admin/repositories/aluno.repository'
import { ViewType } from '../student.admin'
import { useState } from 'react'
import { IDocument } from './documents'

interface ICreateDocument {
  tipo: string
  arquivo: File
}

export interface IStudentProps {
  setLoading: React.Dispatch<React.SetStateAction<Boolean>>
  setDocuments: React.Dispatch<React.SetStateAction<IDocument[]>>
  setView: React.Dispatch<React.SetStateAction<ViewType>>
}

export const Document = ({
  setView,
  setDocuments,
  setLoading,
}: IStudentProps) => {
  const { token } = useAuth()
  const { id } = useParams()
  const [document, setDocument] = useState({} as ICreateDocument)

  async function addDocument() {
    try {
      setLoading(true)
      const newDocument = await AlunoRepository.GetInstance().adminAddDocument(
        token,
        id,
        document.arquivo,
        document.tipo,
      )
      setDocument({} as ICreateDocument)
      setDocuments((state) => [...state, newDocument])
      setView('DOCUMENTS')
    } catch (error) {
      console.log('error: ', error)
    } finally {
      setLoading(false)
    }
  }

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <input
        value={document?.tipo}
        onChange={(e) =>
          setDocument((state) => ({ ...state, tipo: e.target.value }))
        }
        placeholder="tipo"
      />
      <input
        type="file"
        onChange={(e) =>
          setDocument((state) => ({ ...state, arquivo: e.target.files[0] }))
        }
      />
      <button onClick={addDocument}>Adicionar</button>
      <button onClick={() => setView('DOCUMENTS')}>Cancelar</button>
    </div>
  )
}
